import 'flag-icon-css/css/flag-icon.css';

import { ChallengeResult, closeChallengeDialog } from '../../../modules/challenge';
import { CircularProgress, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../../modules';
import React, { Component, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { challenge as soapChallenge, queryAuthStatus as soapQueryAuthStatus } from '../../../modules/api';

import Button from '@material-ui/core/Button';
import ChallengeRequestProps from './ChallengeRequestProps';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  progress: {
    display: 'block',
    margin: `${theme.spacing(2)}px auto`,
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  error: {
    color: theme.palette.error.main
  },
})

type State = {
  loading: boolean
  acspChallengeStatus: string
  timeoutId: ReturnType<typeof setTimeout> | null
  error: string,
  nextCheck: number | null
};

class TrxSignChallengeRequest extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      loading: true,
      acspChallengeStatus: "",
      error: "",
      timeoutId: null,
      nextCheck: null,
    }
  }

  readonly QueryAuthStatusInterval = 5

  componentWillMount() {
    this.handleChallenge()
  }

  handleChallenge() {
    console.log(this.props.challenge.analyzeRequest)
    let transactionData = this.props.challenge.analyzeRequest.eventDataList.eventData.transactionData
    console.log(transactionData)
    let args = {
      credentialChallengeRequestList: {
        acspChallengeRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "TrxSignChallengeRequest",
                xmlns: "http://trx.csd.rsa.com"
              },
            },
            "ns1:payload": {
              $attributes: {
                xmlns: "http://trx.csd.rsa.com",
              },
              amount: transactionData.amount.amount,
              currency: transactionData.amount.currency,
              fromAccountNickname: transactionData.myAccountData.accountNickName,
              fromAccountNumber: transactionData.myAccountData.accountNumber,
              payeeName: transactionData.otherAccountData.accountNickName,
              payeeAccountNumber: transactionData.otherAccountData.accountNumber,
            }
          }
        }
      }
    }

    this.setState({
      loading: true,
    })
    this.props.soapChallenge(args).then((data: any) => {
      try {
        let callStatus = data.credentialChallengeList.acspChallengeResponseData.callStatus

        if (callStatus.statusCode !== "SUCCESS")
          throw new Error("callStatus.statusCode is " + callStatus.statusCode)

        this.setState({
          loading: false,
          acspChallengeStatus: callStatus.statusCode,
        })
        this.scheduleCheck()

      } catch (error) {
        console.error(error)
        this.setState({ loading: false, error: error.toString() })
      }
    }).catch((error: Error) => {
      console.error(error)
      this.setState({ loading: false, error: error.toString() })
    })
  }

  handleQueryAuthStatus = () => {
    let args = {
      credentialAuthStatusRequest: {
        acspAuthStatusRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "TrxSignAuthStatusRequest",
                xmlns: "http://trx.csd.rsa.com"
              }
            }
          }
        }
      }
    }
    this.props.soapQueryAuthStatus(args)
      .then((data: any) => {
        let status = data.credentialAuthStatusResponse.acspAuthStatusResponseData.callStatus.statusCode

        if (status === "PENDING") {
          this.scheduleCheck()
          return
        }

        if (status === "SUCCESS") {
          this.props.challengeResponse(ChallengeResult.Success)
        }
        else {
          this.props.challengeResponse(ChallengeResult.Failure)
        }
      }).catch((error: Error) => {
        this.props.challengeResponse(ChallengeResult.Error)
      })
  }

  handleBack = () => {
    this.props.challengeResponse(ChallengeResult.Pending)
  }

  handleCheck = () => {
    if (this.state.timeoutId)
      clearTimeout(this.state.timeoutId)

    this.setState({
      timeoutId: null,
      nextCheck: null
    })

    this.handleQueryAuthStatus()
  }

  scheduleCheck = () => {
    if (this.state.timeoutId)
      clearTimeout(this.state.timeoutId)

    this.setState({
      timeoutId: setTimeout(this.handleQueryAuthStatus, this.QueryAuthStatusInterval * 1000),
      nextCheck: new Date().getTime() + this.QueryAuthStatusInterval * 1000
    })
  }

  render() {
    const { loading, error, nextCheck } = this.state
    const { classes } = this.props

    console.log(nextCheck, new Date().getTime())
    return (
      <Fragment>
        {loading && !error &&
          <CircularProgress className={classes.progress} />
        }

        {!loading &&
          <Fragment>
            <DialogContent>
              <Typography className={classes.error}>{error}</Typography>
              <DialogContentText>
                Push notification sent! Please approve the transaction on your mobile device.
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.handleCheck} color="primary">
                Check Now
              </Button>
              <Button onClick={this.handleBack} color="default">
                Back
              </Button>
            </DialogActions>
          </Fragment>
        }

      </Fragment>
    )
  }
}


const mapStateToProps = ({ auth, authmethods, challenge }: IStoreState) => ({
  auth,
  authmethods,
  challenge
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      soapChallenge,
      soapQueryAuthStatus,
      closeChallengeDialog
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, ChallengeRequestProps {
  // refer to ChallengeRequestProps.ts
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TrxSignChallengeRequest));